const dashboard = {
  // Page-level
  "dashboard.title": "Dashboard",
  "dashboard.connectPrompt": "Connect WhatsApp to get started",
  "dashboard.session": "Session",
  "dashboard.plan": "Plan",
  "dashboard.loading": "Loading dashboard...",
  "dashboard.error.title": "Failed to Load Data",
  "dashboard.error.needReconnect": "Your WhatsApp session needs to be reconnected. Restarting the scan will let you scan a new QR code.",
  "dashboard.error.restartScan": "Restart Scan",
  "dashboard.error.signInAgain": "Sign in again",
  "dashboard.error.tokenExpiredDesc": "Your authentication token or session has expired on the server. Logging in again with your phone number will refresh your session immediately.",
  "dashboard.tabs.overview": "Overview",
  "dashboard.tabs.automation": "Automation",
  "dashboard.tabs.knowledge": "Knowledge Base",
  "dashboard.tabs.blacklist": "Blacklist",
  "dashboard.tabs.whatsapp": "Chats",
  "dashboard.tabs.crm": "CRM",
  "dashboard.tabs.catalog": "Catalog",
  "dashboard.quickInfo.plan": "Plan",
  "dashboard.quickInfo.session": "Session",
  "dashboard.quickInfo.csvRows": "CSV Rows",
  "dashboard.quickInfo.blacklisted": "Blacklisted",
  "dashboard.toast.disconnected": "WhatsApp session disconnected. Restarting scan...",
  "dashboard.quickInfo.title": "Quick Info",

  // StatsCards
  "stats.totalUsage": "Total Usage",
  "stats.averageUsage": "Average usage across all resources",
  "stats.trendingUp": "Your overall usage is trending up. Consider upgrading soon.",
  "stats.trendingDown": "Your overall usage is trending down.",
  "stats.trendingFlat": "Your overall usage is trending flat.",
  "stats.exceededLimit": " You've exceeded your plan limit on some resources. ",
  "stats.upgradePrompt": "Upgrade your plan to increase limits.",
  "stats.messages": "Messages",
  "stats.usedMessages": "Used Messages",
  "stats.tokens": "Tokens",
  "stats.inputTokens": "Input Tokens",
  "stats.outputTokens": "Output Tokens",
  "stats.of": "of",
  "stats.usageStatistics": "Usage Statistics",
  "stats.last7Days": "Last 7 days trend",

  // ChatListSidebar
  "chatList.title": "Chats",
  "chatList.bulkMessage": "Bulk Message",
  "chatList.crmPipeline": "CRM Pipeline",
  "chatList.refreshChats": "Refresh chats",
  "chatList.searchPlaceholder": "Search or start a new chat",
  "chatList.filterAll": "All",
  "chatList.filterUnread": "Unread",
  "chatList.filterGroups": "Groups",
  "chatList.tryAgain": "Try again",
  "chatList.noChats": "No chats yet",
  "chatList.you": "You",
  "chatList.yesterday": "Yesterday",
  "chatList.archived": "Archived",
  "chatList.noArchivedChats": "No archived chats",
  "chatList.igConnectionAlert": "Instagram Connection Alert",
  "chatList.errorLoadingChats": "Error loading chats",
  "chatList.reconnectInstagram": "Reconnect Instagram",
  "chatList.photo": "Photo",
  "chatList.video": "Video",
  "chatList.voiceMessage": "Voice Message",
  "chatList.audio": "Audio",
  "chatList.document": "Document",
  "chatList.location": "Location",
  "chatList.sticker": "Sticker",
  "chatList.contact": "Contact",
  "chatList.poll": "Poll",
  "chatList.gif": "GIF",
  "chatList.product": "Product",
  "chatList.call": "Call",
  "chatList.catalog": "Catalog",
  "chatList.order": "Order",
  "chatList.template": "Template",
  "chatList.button": "Button",
  "chatList.interactiveMessage": "Interactive Message",
  "chatList.disappearingMessage": "Disappearing Message",
  "chatList.groupEvent": "Group Event",
  "chatList.notification": "Notification",
  "chatList.broadcast": "Broadcast",
  "chatList.typing": "typing...",
  "chatList.recordingAudio": "recording audio...",

  // ChatWindow
  "chatWindow.title": "WhatsApp Chat",
  "chatWindow.titleInstagram": "Instagram Direct Chats",
  "chatWindow.titleFacebook": "Facebook Messenger",
  "chatWindow.titleAll": "Unified Messaging",
  "chatWindow.emptyText": "Select a conversation from the list to start chatting. Messages update in real time.",
  "chatWindow.group": "Group",
  "chatWindow.business": "Business",
  "chatWindow.refreshMessages": "Refresh messages",
  "chatWindow.today": "Today",
  "chatWindow.yesterday": "Yesterday",
  "chatWindow.noMessages": "No messages yet",
  "chatWindow.startConversation": "Send a message to start the conversation",
  "chatWindow.back": "Back",
  "chatWindow.typing": "typing...",
  "chatWindow.recordingAudio": "recording audio...",
  "chatWindow.viewContactSummary": "View contact info & summary",
  "chatWindow.smartSummary": "Smart Summary",
  "chatWindow.summary": "Summary",
  "contactDrawer.generatingSummary": "Analyzing conversation and generating summary...",
  "contactDrawer.noSummaryYet": "No summary generated for this conversation yet",
  "contactDrawer.generate": "Generate",
  "contactDrawer.done": "Done",

  // ChatInput
  "chatInput.aiReplying": "AI is generating a reply...",
  "chatInput.replying": "Replying...",
  "chatInput.shareLocation": "Share Location",
  "chatInput.locationName": "Location name *",
  "chatInput.address": "Address",
  "chatInput.latitude": "Latitude *",
  "chatInput.longitude": "Longitude *",
  "chatInput.sending": "Sending...",
  "chatInput.sendLocation": "Send Location",
  "chatInput.shareLink": "Share Link",
  "chatInput.url": "URL *",
  "chatInput.captionOptional": "Caption (optional)",
  "chatInput.sendLink": "Send Link",
  "chatInput.recordVoice": "Record voice",
  "chatInput.attach": "Attach",
  "chatInput.aiAssistantPrompt": "AI Message Assistant",
  "chatInput.typeMessage": "Type a message",
  "chatInput.locationUnavailable": "Geolocation is not supported by your browser",
  "chatInput.locationPermissionDenied": "Please enable location permissions in your browser",
  "chatInput.liveLocationTitle": "📍 My Current Location (Live Location)",

  // WhatsAppSessionPanel
  "wpp.readyToConnect": "Ready to connect",
  "wpp.generatingToken": "Generating token...",
  "wpp.tokenGenerated": "Token generated",
  "wpp.startingSession": "Starting session...",
  "wpp.waitingForQR": "Waiting for QR scan",
  "wpp.sessionConnected": "Session connected",
  "wpp.connectionError": "Connection error",
  "wpp.stepToken": "Token",
  "wpp.stepQR": "QR Code",
  "wpp.stepConnected": "Connected",
  "wpp.noSession": "No session available. Please log in first.",
  "wpp.title": "WhatsApp Session",
  "wpp.sessionLabel": "Session:",
  "wpp.statusConnected": "Connected",
  "wpp.statusWaiting": "Waiting",
  "wpp.statusGenerating": "Generating",
  "wpp.statusStarting": "Starting",
  "wpp.statusChecking": "Checking",
  "wpp.reset": "Reset",
  "wpp.connectPrompt": "Generate a token and start your WhatsApp session to connect your number.",
  "wpp.connectBtn": "Connect WhatsApp",
  "wpp.generatingDesc": "Generating secure token...",
  "wpp.generatingSub": "Contacting server for authentication",
  "wpp.startingDesc": "Starting WhatsApp session...",
  "wpp.startingSub": "Initializing connection",
  "wpp.tokenReady": "Token generated successfully",
  "wpp.startSession": "Start Session",
  "wpp.scanTitle": "Scan with WhatsApp",
  "wpp.scanDesc": "Open WhatsApp on your phone, go to <strong>Settings &gt; Linked Devices</strong>, and scan this QR code.",
  "wpp.checkNow": "Check Now",
  "wpp.startOver": "Start Over",
  "wpp.autoCheck": "Auto-checking every 5 seconds...",
  "wpp.connectedTitle": "WhatsApp is Connected",
  "wpp.connectedDesc": "Your session {{name}} is active and ready.",
  "wpp.verifyConnection": "Verify Connection",
  "wpp.errorTitle": "Error",

  // AutomationPanel
  "automation.title": "Automation Controls",
  "automation.subtitle": "Configure AI smart responses, business hours, and automated workflows.",
  "automation.statusUpdated": "Status updated!",
  "automation.failedUpdate": "Failed to update",
  "automation.statusTitle": "Automation Status",
  "automation.statusActive": "Bot is actively replying to messages",
  "automation.statusPaused": "Bot is currently paused",
  "automation.lastUpdated": "Last updated:",
  "automation.replySettings": "Reply Settings",
  "automation.replySettingsUpdated": "Reply settings updated!",
  "automation.voiceMessages": "Voice Messages",
  "automation.voiceDesc": "Auto-reply with voice notes",
  "automation.imageReplies": "Image Replies",
  "automation.imageDesc": "Auto-reply with images",
  "automation.documentReplies": "Document Replies",
  "automation.documentDesc": "Auto-reply with documents",
  "automation.followupTitle": "Smart Drip Follow-up",
  "automation.followupDesc": "Automated friendly reminder when a customer stops replying, boosting sales & bookings.",
  "automation.followupDelay": "Send reminder after inactive period:",
  "automation.followupDelay6h": "After 6 hours",
  "automation.followupDelay12h": "After 12 hours",
  "automation.followupDelay24h": "After 24 hours",
  "automation.followupDelay48h": "After 48 hours",
  "automation.followupMessage": "Follow-up message:",
  "automation.useTemplate": "Use suggested template",
  "automation.followupTagHint": "Use {name} to insert customer name",
  "automation.characters": "chars",
  "automation.guardTitle": "Smart Guardrails & Anti-Spam:",
  "automation.guardDesc": "Automatically cancelled if the customer replies or books an appointment. Sent once with zero tokens consumed.",
  "automation.followupActive": "Follow-up is active & ready",
  "automation.followupDisabled": "Follow-up is disabled",
  "automation.previewTitle": "Live WhatsApp Preview:",
  "automation.sampleCustomer": "Alex",
  "automation.quietHoursTitle": "Quiet Hours (Do Not Disturb)",
  "automation.quietHoursDesc": "Pause follow-ups overnight and send automatically the next morning",
  "automation.quietHoursFrom": "From:",
  "automation.quietHoursTo": "To:",
  "automation.saveFollowupBtn": "Save Settings",
  "automation.followupSaved": "Follow-up settings saved successfully!",
  "automation.followupStatsSent": "{{count}} follow-ups sent this week",
  "automation.followupStatsPending": "({{count}} queued)",
  "automation.followupStatsActive": "Follow-up active & monitoring",
  "automation.defaultFollowupMessage": "Hello! Just checking in to see if you have any questions or if we can help with anything!",
  "automation.quietHoursSummary": "Quiet window: {{start}} to {{end}} ({{duration}}h pause)",
  "automation.quietHoursDefault": "System default: 10:00 PM to 9:00 AM",
  "automation.resetDefault": "Reset default",
  "automation.periodPM": "PM",
  "automation.periodAM": "AM",

  // KnowledgeBasePanel
  "kb.title": "Knowledge Base & AI Intelligence",
  "kb.subtitle": "Customize your facility profile & train your AI assistant for your specific industry",
  "kb.facilityType": "Facility / Business Category",
  "kb.facilityTypeDesc": "Select your industry to dynamically adapt knowledge sections & AI persona",
  "kb.facility.ecommerce": "E-Commerce & Retail",
  "kb.facility.ecommerceDesc": "Products, pricing, stock, specs, and delivery policies",
  "kb.facility.agency": "Marketing & Digital Agencies",
  "kb.facility.agencyDesc": "Digital services, marketing packages, deliverables & pricing",
  "kb.facility.gym": "Gym & Fitness Centers",
  "kb.facility.gymDesc": "Membership plans, personal trainers, schedule & facilities",
  "kb.facility.clinic": "Clinics & Healthcare",
  "kb.facility.clinicDesc": "Doctors, specialties, consultation fees & booking",
  "kb.facility.restaurant": "Restaurants & Cafes",
  "kb.facility.restaurantDesc": "Menu dishes, pricing, branches, and delivery areas",
  "kb.facility.realestate": "Real Estate & Projects",
  "kb.facility.realestateDesc": "Units, projects, payment plans, and locations",
  "kb.facility.custom": "Custom / General Business",
  "kb.facility.customDesc": "Fully flexible structure for any other business sector",

  "kb.facility.ecommerce.singular": "Product",
  "kb.facility.ecommerce.plural": "Products & Inventory",
  "kb.facility.ecommerce.field.name.label": "Product Name",
  "kb.facility.ecommerce.field.name.placeholder": "Product title and model (e.g. Wireless Bluetooth Headphones Pro X200)",
  "kb.facility.ecommerce.field.category.label": "Category",
  "kb.facility.ecommerce.field.category.placeholder": "Category or department (e.g. Electronics, Menswear, Skincare)",
  "kb.facility.ecommerce.field.price.label": "Price",
  "kb.facility.ecommerce.field.price.placeholder": "Price, currency, and discounts (e.g. $49.99 / 450 EGP after 25% discount)",
  "kb.facility.ecommerce.field.stock.label": "Stock Status",
  "kb.facility.ecommerce.field.stock.placeholder": "Availability status (e.g. In stock, Out of stock, Available for pre-order)",
  "kb.facility.ecommerce.field.description.label": "Description & Specs",
  "kb.facility.ecommerce.field.description.placeholder": "Features, specifications, sizes or colors (e.g. 24h battery, noise cancellation, Black/White)",
  "kb.facility.ecommerce.field.url.label": "Product URL",
  "kb.facility.ecommerce.field.url.placeholder": "Link to product page or checkout (e.g. https://yourstore.com/item-123)",

  "kb.facility.agency.singular": "Service / Package",
  "kb.facility.agency.plural": "Services & Marketing Packages",
  "kb.facility.agency.field.name.label": "Service / Package Name",
  "kb.facility.agency.field.name.placeholder": "Service or package name (e.g. Paid Advertising Management / Complete Brand Identity)",
  "kb.facility.agency.field.category.label": "Service Area",
  "kb.facility.agency.field.category.placeholder": "Service area or specialty (e.g. Media Buying, SEO Optimization, Web Development)",
  "kb.facility.agency.field.price.label": "Pricing / Estimated Budget",
  "kb.facility.agency.field.price.placeholder": "Pricing or starting budget (e.g. Starting from $500/month / Custom Quote on demand)",
  "kb.facility.agency.field.timeline.label": "Delivery Timeline",
  "kb.facility.agency.field.timeline.placeholder": "Estimated turnaround time (e.g. 7-10 business days / Ongoing Monthly Retainer)",
  "kb.facility.agency.field.deliverables.label": "Deliverables & Scope",
  "kb.facility.agency.field.deliverables.placeholder": "Deliverables & scope breakdown (e.g. Campaign setup, 12 ad creatives, copy, weekly analytics report)",
  "kb.facility.agency.field.portfolio_link.label": "Portfolio / Case Studies Link",
  "kb.facility.agency.field.portfolio_link.placeholder": "Portfolio or case studies reference URL (e.g. https://agency.com/case-studies)",

  "kb.facility.gym.singular": "Membership Plan",
  "kb.facility.gym.plural": "Memberships & Training Plans",
  "kb.facility.gym.field.name.label": "Plan Name",
  "kb.facility.gym.field.name.placeholder": "Membership plan title (e.g. 3-Month Platinum Pass / VIP Personal Training Package)",
  "kb.facility.gym.field.duration.label": "Duration",
  "kb.facility.gym.field.duration.placeholder": "Validity period and active duration (e.g. 1 Month / 3 Months / 1 Year)",
  "kb.facility.gym.field.price.label": "Subscription Price",
  "kb.facility.gym.field.price.placeholder": "Subscription fee with taxes (e.g. $90 / 250 SAR)",
  "kb.facility.gym.field.trainer_included.label": "Trainer & Follow-up",
  "kb.facility.gym.field.trainer_included.placeholder": "Personal trainer and body assessment (e.g. Includes 8 PT sessions + monthly InBody checkup)",
  "kb.facility.gym.field.features.label": "Included Features & Perks",
  "kb.facility.gym.field.features.placeholder": "Included perks and facilities (e.g. Unlimited gym access, sauna, jacuzzi, group fitness classes)",

  "kb.facility.clinic.singular": "Doctor / Medical Service",
  "kb.facility.clinic.plural": "Doctors & Clinical Services",
  "kb.facility.clinic.field.name.label": "Doctor / Service Name",
  "kb.facility.clinic.field.name.placeholder": "Doctor name & sub-specialty (e.g. Dr. John Adams (Senior Dental Implant Consultant))",
  "kb.facility.clinic.field.specialty.label": "Medical Specialty",
  "kb.facility.clinic.field.specialty.placeholder": "Medical specialty or clinic department (e.g. Dentistry, Dermatology & Laser, Pediatrics)",
  "kb.facility.clinic.field.fee.label": "Consultation Fee",
  "kb.facility.clinic.field.fee.placeholder": "Consultation fee & follow-up (e.g. $50 includes free follow-up consultation within 14 days)",
  "kb.facility.clinic.field.schedule.label": "Available Schedule & Days",
  "kb.facility.clinic.field.schedule.placeholder": "Clinic working days and hours (e.g. Mon, Wed & Sat from 5 PM to 9 PM)",
  "kb.facility.clinic.field.bio.label": "Doctor Bio & Credentials",
  "kb.facility.clinic.field.bio.placeholder": "Credentials, degrees, and medical background (e.g. Board Certified, specialized in advanced dental implants)",

  "kb.facility.restaurant.singular": "Menu Item / Dish",
  "kb.facility.restaurant.plural": "Menu Items & Dishes",
  "kb.facility.restaurant.field.name.label": "Item / Dish Name",
  "kb.facility.restaurant.field.name.placeholder": "Dish or menu item name (e.g. Double Angus Cheese Burger / Italian Truffle Pizza)",
  "kb.facility.restaurant.field.category.label": "Menu Category",
  "kb.facility.restaurant.field.category.placeholder": "Menu section or category (e.g. Burgers, Pizza, Appetizers, Grills, Drinks)",
  "kb.facility.restaurant.field.price.label": "Price",
  "kb.facility.restaurant.field.price.placeholder": "Price or starting size (e.g. $12.99 / 35 SAR)",
  "kb.facility.restaurant.field.ingredients.label": "Ingredients & Description",
  "kb.facility.restaurant.field.ingredients.placeholder": "Ingredients and allergen notice (e.g. 200g grilled Angus beef, melted cheddar, house sauce, brioche bun)",
  "kb.facility.restaurant.field.size_or_options.label": "Sizes & Customizations",
  "kb.facility.restaurant.field.size_or_options.placeholder": "Available sizes and add-ons (e.g. Single / Combo with fries & drink for $3 / Extra melted cheese)",

  "kb.facility.realestate.singular": "Unit / Project",
  "kb.facility.realestate.plural": "Units & Real Estate Projects",
  "kb.facility.realestate.field.name.label": "Unit / Project Name",
  "kb.facility.realestate.field.name.placeholder": "Unit title or project name (e.g. Duplex Apartment at Palm Hills / Standalone Villa at Zed)",
  "kb.facility.realestate.field.type.label": "Property Type",
  "kb.facility.realestate.field.type.placeholder": "Property type & usage (e.g. Residential Apartment, Townhouse, Standalone Villa, Commercial Store)",
  "kb.facility.realestate.field.area.label": "Area & Layout",
  "kb.facility.realestate.field.area.placeholder": "Total area and room layout (e.g. 185 sqm (3 Bedrooms + 2 Bathrooms + Spacious Reception))",
  "kb.facility.realestate.field.price.label": "Total Price / Downpayment",
  "kb.facility.realestate.field.price.placeholder": "Total price & down payment (e.g. $250,000 (10% Down Payment = $25,000))",
  "kb.facility.realestate.field.payment_plan.label": "Installment & Payment Plan",
  "kb.facility.realestate.field.payment_plan.placeholder": "Installment schedule and plan (e.g. Equal installments over 8 years with 0% interest)",
  "kb.facility.realestate.field.location.label": "Location & Project Area",
  "kb.facility.realestate.field.location.placeholder": "Location & nearby landmarks (e.g. Golden Square, 5th Settlement - near AUC)",
  "kb.facility.realestate.field.features.label": "Features & Handover Date",
  "kb.facility.realestate.field.features.placeholder": "Amenities, finishing, and delivery date (e.g. Lake view, private garage, 24/7 security, handover in 2 years)",

  "kb.facility.custom.singular": "Item / Entry",
  "kb.facility.custom.plural": "Custom Items & Catalog",
  "kb.facility.custom.field.name.label": "Item / Title Name",
  "kb.facility.custom.field.name.placeholder": "Item, service, or entry name (e.g. Annual Maintenance Package / Technical Consultation)",
  "kb.facility.custom.field.category.label": "Category / Type",
  "kb.facility.custom.field.category.placeholder": "Category or classification (e.g. General Services, Consulting, Custom Products)",
  "kb.facility.custom.field.price.label": "Price / Cost",
  "kb.facility.custom.field.price.placeholder": "Price or rate if applicable (e.g. $50 / Free for clients / Quoted on demand)",
  "kb.facility.custom.field.description.label": "Details & Description",
  "kb.facility.custom.field.description.placeholder": "Detailed explanation of this item for clients and AI (e.g. Comprehensive inspection with official report)",
  "kb.facility.custom.field.link.label": "Additional URL / Reference",
  "kb.facility.custom.field.link.placeholder": "Additional URL or reference link (e.g. https://yoursite.com/service-123)",

  "kb.profileSection": "Business / Facility Profile",
  "kb.profileDesc": "General company overview, contact details, and working hours",
  "kb.catalogSection": "Catalog / Services & Packages",
  "kb.catalogDesc": "Detailed offerings and pricing your AI assistant references",
  "kb.policySection": "Policies, Guidelines & FAQ",
  "kb.policyDesc": "Terms of service, refund/return policies, booking instructions",
  "kb.customSection": "Custom Additional Fields",
  "kb.customDesc": "Add any extra key-value information your AI should know",
  "kb.faq.title": "Customer intake questions",
  "kb.faq.description": "Create the questions the assistant asks when a specific case or request starts",
  "kb.faq.question": "Assistant question",
  "kb.faq.answer": "How to handle the answer",
  "kb.faq.topic": "When to ask / trigger",
  "kb.faq.add": "Add intake question",
  "kb.faq.questionHint": "Example: What is your main complaint?",
  "kb.faq.answerHint": "Example: Save the answer, then continue or hand off to the team",
  "kb.faq.topicHint": "Example: When a customer asks to book a specific service",
  "kb.faq.suggestions.clinic": "Create a separate flow for each specialty: dental, eye care, physiotherapy, dermatology…",
  "kb.faq.suggestions.gym": "Memberships, classes, training, and freezes",
  "kb.faq.suggestions.restaurant": "Delivery, allergens, reservations, and payments",
  "kb.faq.suggestions.ecommerce": "Shipping, returns, stock, and warranty",
  "kb.faq.suggestions.realestate": "Viewings, payment plans, and documents",
  "kb.faq.suggestions.agency": "Scope, timeline, pricing, and support",
  "kb.faq.suggestions.custom": "Pricing, availability, and getting started",

  "kb.importCsv": "Import",
  "kb.resetBtn": "Reset",
  "kb.resetConfirmTitle": "Reset Knowledge Base?",
  "kb.resetConfirmDesc": "This will clear all form fields, items, and custom inputs so you can enter your knowledge from scratch.",
  "kb.confirmReset": "Confirm",
  "kb.cancel": "Cancel",
  "kb.resetDone": "Data cleared successfully.",
  "kb.addItem": "Add",
  "kb.addCustomField": "Add",
  "kb.customKey": "Field Name / Key",
  "kb.customKeyPlaceholder": "Attribute name (e.g. Promo Code, Warranty Period, International Shipping)",
  "kb.customValue": "Value / Info",
  "kb.customValuePlaceholder": "Value & details (e.g. 10% off with code WYZON10, 2-Year official warranty)",
  "kb.removeCustomField": "Delete",
  "kb.submitCsv": "Save",
  "kb.submitting": "Saving...",
  "kb.fillRequired": "Please fill in at least one field before saving",
  "kb.submitSuccess": "Saved successfully",
  "kb.submitFailed": "Failed to save Knowledge Base",
  "kb.fieldsFilled": "{{total}} fields filled across {{sections}} sections",
  "kb.fieldsCount": "{{filled}}/{{total}} fields",
  "kb.removeItem": "Delete",
  "kb.itemDefault": "Item {{index}}",

  // Subscription Lock Overlay
  "lock.badge": "Wyzon AI Official Guarantee",
  "lock.expiredTitle": "Your subscription has ended",
  "lock.limitTitle": "Your plan quota limit has been reached",
  "lock.expiredDesc": "Choose a plan to renew your subscription or upgrade to keep evaluating and executing AI workflows with Wyzon.",
  "lock.limitDesc": "You have reached the maximum message or token capacity for your current plan. Please upgrade to continue seamless AI operations.",
  "lock.buyPlanBtn": "Buy a plan",
  "lock.contactSupportBtn": "Contact support",
  "lock.card1.title": "Plan & Quota Details",
  "lock.card1.planName": "Plan: {{name}}",
  "lock.card1.messages": "Messages: {{used}} / {{limit}} ({{percent}}%)",
  "lock.card1.expiredDate": "Expires: {{date}}",
  "lock.card1.upgrade": "Upgrade plan",
  "lock.card2.title": "Upcoming AI features",
  "lock.card2.desc": "Explore automated Voice Notes, Media Catalog integration, and smart CRM AI workflows.",
  "lock.card2.link": "Learn more",
  "lock.card3.title": "Priority Support & Setup",
  "lock.card3.desc": "Get dedicated account setup assistance and priority 24/7 support for your AI assistant.",
  "lock.card3.link": "Contact us",

  // Base Profile Fields
  "kb.field.name": "Business / Facility Name",
  "kb.field.namePlaceholder": "Enter your official business name as known to customers (e.g. Zad Fashion / Cure Clinic / Shawarma King)",
  "kb.field.industry": "Industry / Specialty",
  "kb.field.industryPlaceholder": "Specify your business category (e.g. Fashion Retail, Dental Clinic, Fitness Gym, Digital Marketing)",
  "kb.field.description": "Comprehensive Overview",
  "kb.field.descriptionPlaceholder": "Brief overview of what you offer and your key value propositions for the AI to recommend you (e.g. Boutique fashion brand with fast delivery and easy returns)",
  "kb.field.phone": "Phone / Hotline",
  "kb.field.phonePlaceholder": "Customer support or WhatsApp phone number (e.g. +201012345678 or 19999)",
  "kb.field.email": "Email",
  "kb.field.emailPlaceholder": "Official contact email for inquiries and support (e.g. info@yourbusiness.com)",
  "kb.field.website": "Website",
  "kb.field.websitePlaceholder": "Your official website or store URL (e.g. https://yourbrand.com)",
  "kb.field.workingHours": "Working Hours & Schedule",
  "kb.field.workingHoursPlaceholder": "Daily operating schedule and client hours (e.g. Sat-Thu from 10 AM to 10 PM, Friday from 2 PM)",
  "kb.field.address": "Physical Address & Location",
  "kb.field.addressPlaceholder": "Detailed branch address or service areas (e.g. 15 Al-Nasr St, Maadi, Cairo)",
  "kb.field.paymentMethods": "Accepted Payment Methods",
  "kb.field.paymentMethodsPlaceholder": "Accepted payment and transfer methods (e.g. Cash on Delivery, Visa/Mastercard, Vodafone Cash, InstaPay, Tabby)",
  "kb.field.valuePlaceholder": "Enter {{field}}",
  "kb.field.warrantyPolicy": "Warranty Policy",
  "kb.field.warrantyPolicyPlaceholder": "Warranty duration, terms, and how customers can use it",
  "kb.dynamicField.medical_specialties": "Available Medical Specialties",
  "kb.dynamicField.booking_channels": "Available Booking Channels",
  "kb.dynamicField.emergency_contact": "Emergency Contact",
  "kb.dynamicField.fitness_focus": "Fitness Focus Areas",
  "kb.dynamicField.cuisine_type": "Cuisine Type",
  "kb.dynamicField.ordering_channels": "Available Ordering Channels",
  "kb.dynamicField.customer_support_channels": "Customer Support Channels",
  "kb.dynamicField.service_areas": "Service Areas",
  "kb.dynamicField.company_overview": "Company Overview",

  // Facility-Specific Profile Fields
  "kb.field.shippingPolicy": "Shipping & Delivery Policy",
  "kb.field.shippingPolicyPlaceholder": "Specify shipping timeframe, fees, and coverage (e.g. Delivery in 2-4 days, free above 500 EGP, shipping nationwide)",
  "kb.field.returnPolicy": "Return & Refund Policy",
  "kb.field.returnPolicyPlaceholder": "Product return and exchange guidelines (e.g. Free return or exchange within 14 days with original packaging and receipt)",
  "kb.field.targetAudience": "Target Clients & Industries",
  "kb.field.targetAudiencePlaceholder": "Specify ideal customer profile and sectors (e.g. Startups, E-commerce stores, Healthcare clinics & centers)",
  "kb.field.paymentTerms": "Contract & Payment Terms",
  "kb.field.paymentTermsPlaceholder": "Payment milestones & deposit policy (e.g. 50% upfront deposit to commence, 50% upon final delivery & sign-off)",
  "kb.field.genderSchedule": "Ladies / Men Schedules",
  "kb.field.genderSchedulePlaceholder": "Designated ladies and mixed hours (e.g. Ladies hours daily 10 AM - 2 PM, remaining schedule is mixed)",
  "kb.field.amenities": "Facilities & Equipment",
  "kb.field.amenitiesPlaceholder": "Available perks and amenities for members (e.g. Modern cardio & weights floor, sauna, jacuzzi, lockers, free Wi-Fi)",
  "kb.field.gymRules": "Club Rules & Regulations",
  "kb.field.gymRulesPlaceholder": "Club dress code and freeze policy (e.g. 1-month freeze allowed per 3-month membership, athletic attire & clean shoes required)",
  "kb.field.bookingInstructions": "Booking & Appointment Guidelines",
  "kb.field.bookingInstructionsPlaceholder": "How to schedule and confirm appointments (e.g. Prior booking required via WhatsApp or phone, please arrive 15 minutes before slot)",
  "kb.field.emergencyInfo": "Emergency Hotline",
  "kb.field.emergencyInfoPlaceholder": "24/7 urgent contact numbers (e.g. Emergency Hotline 19000 or urgent WhatsApp +201100000000)",
  "kb.field.insuranceAccepted": "Accepted Medical Insurance",
  "kb.field.insuranceAcceptedPlaceholder": "List of contracted health insurance networks (e.g. AXA, Bupa, Care Plus, MetLife, MedNet, Allianz)",
  "kb.field.deliveryAreas": "Delivery Areas & Minimum Order",
  "kb.field.deliveryAreasPlaceholder": "Coverage zones, delivery fees, and minimum spend (e.g. All Greater Cairo, minimum order 100 EGP, delivery fee 25 EGP)",
  "kb.field.branchesList": "Branches & Locations",
  "kb.field.branchesListPlaceholder": "Your branches with addresses (e.g. Nasr City: 10 Abbas El-Akkad / Maadi: El-Nasr St next to NBE)",
  "kb.field.dineInReservations": "Table Reservations & Events",
  "kb.field.dineInReservationsPlaceholder": "Table and party reservation policy (e.g. Table reservation 2 hours in advance, private birthday room available for min 10 guests)",
  "kb.field.developerName": "Developer / Master Entity",
  "kb.field.developerNamePlaceholder": "Master real estate developer or parent entity (e.g. Talaat Moustafa Group / Emaar Misr / SODIC)",
  "kb.field.bookingSteps": "Contract & Booking Procedure",
  "kb.field.bookingStepsPlaceholder": "Reservation deposit and documentation (e.g. 50,000 EGP refundable reservation deposit, valid national ID copy needed)",


  // BlacklistPanel
  "blacklist.title": "Blacklist",
  "blacklist.addNumber": "Add Number",
  "blacklist.phonePlaceholder": "Enter phone number (e.g. 201234567890)",
  "blacklist.block": "Block",
  "blacklist.invalidPhone": "Enter a valid phone number (10-15 digits, no +)",
  "blacklist.addedSuccess": "Number added to blacklist successfully",
  "blacklist.addedFailed": "Failed to add number, please try again",
  "blacklist.removedSuccess": "Number removed from blacklist",
  "blacklist.removedFailed": "Failed to remove number",
  "blacklist.empty": "Blacklist is Empty",
  "blacklist.emptyDesc": "All customers and phone numbers can currently interact and receive AI automated replies.",
  "blacklist.blockedCount": "Blocked numbers: {{count}}",
  "blacklist.addTitle": "Add Phone Number to Block",
  "blacklist.addSubtitle": "Select country code and type phone number without the leading zero.",
  "blacklist.searchCountry": "Search country...",
  "blacklist.phonePlaceholderDynamic": "Phone (e.g. {{example}})",
  "blacklist.validPhoneDigits": "Please enter a valid phone number ({{digits}} digits)",
  "blacklist.alreadyBlacklisted": "This number is already blacklisted",
  "blacklist.currentNumbers": "Current Blacklisted Numbers ({{count}})",
  "blacklist.searchList": "Search blacklist...",
  "blacklist.noMatch": "No numbers match your search.",
  "blacklist.aiBlocked": "AI Blocked",
  "blacklist.unblock": "Unblock",
  "blacklist.country.20": "Egypt",
  "blacklist.country.966": "Saudi Arabia",
  "blacklist.country.971": "UAE",
  "blacklist.country.965": "Kuwait",
  "blacklist.country.974": "Qatar",
  "blacklist.country.973": "Bahrain",
  "blacklist.country.968": "Oman",
  "blacklist.country.962": "Jordan",
  "blacklist.country.961": "Lebanon",
  "blacklist.country.964": "Iraq",
  "blacklist.country.967": "Yemen",
  "blacklist.country.970": "Palestine",
  "blacklist.country.218": "Libya",
  "blacklist.country.216": "Tunisia",
  "blacklist.country.213": "Algeria",
  "blacklist.country.212": "Morocco",
  "blacklist.country.249": "Sudan",
  "blacklist.country.1": "USA / Canada",
  "blacklist.country.44": "UK",
  "blacklist.country.49": "Germany",
  "blacklist.country.33": "France",
  "blacklist.country.90": "Turkey",
  "blacklist.country.963": "Syria",
  "blacklist.country.91": "India",

  // BulkMessagingPanel
  "bulk.title": "Bulk Messaging",
  "bulk.messageComposer": "Message Composer",
  "bulk.simple": "Simple",
  "bulk.advanced": "Advanced",
  "bulk.messagePlaceholder": "Hi {{name}}! We have an exclusive offer just for you...",
  "bulk.charCount": "{{{count}}} / 4096",
  "bulk.insertVariables": "Insert dynamic variables to personalize messages",
  "bulk.name": "Name",
  "bulk.phone": "Phone",
  "bulk.attach": "Attach",
  "bulk.delayTitle": "Delay Between Messages",
  "bulk.delayDesc": "Reduces spam detection risk. Recommended: 5–15s",
  "bulk.sec": "sec",
  "bulk.randomDelay": "Random Delay",
  "bulk.scheduleTitle": "Schedule Send",
  "bulk.date": "Date",
  "bulk.time": "Time",
  "bulk.campaignScheduled": "Campaign Scheduled",
  "bulk.preview": "Preview",
  "bulk.previewEmpty": "Your message will appear here...",
  "bulk.justNow": "Just now",
  "bulk.contacts": "Contacts",
  "bulk.contactsFormat": "phone, name format",
  "bulk.importCsv": "Import CSV",
  "bulk.clearAll": "Clear all",
  "bulk.sendAll": "Send All",
  "bulk.stopSending": "Stop sending",
  "bulk.scheduleSend": "Schedule Send",
  "bulk.sendingMessages": "Sending messages...",
  "bulk.noContacts": "No contacts found",
  "bulk.importPrompt": "Import a CSV or connect WhatsApp to load contacts",
  "bulk.scheduledBanner": "Sending starts {{date}}, {{time}}",
  "bulk.recipientsWillReceive": "{{count}} contact{{plural}} will receive the message",
  "bulk.cancel": "Cancel",
  "bulk.all": "All",
  "bulk.channelAll": "All",
  "bulk.channelWhatsapp": "WhatsApp",
  "bulk.channelMessenger": "Messenger",
  "bulk.platformColumn": "Channel",
  "bulk.messengerId": "Messenger ID",
  "bulk.filterByChannel": "Filter by Channel",
  "bulk.pending": "Pending",
  "bulk.sent": "Sent",
  "bulk.failed": "Failed",
  "bulk.nameColumn": "Name",
  "bulk.phoneColumn": "Phone",
  "bulk.statusColumn": "Status",
  "bulk.backToChats": "Back to chats",
  "bulk.mobileTabMessage": "Message",
  "bulk.mobileTabContacts": "Contacts",
  "bulk.csvImportSuccess": "Imported {{count}} contact{{plural}}",
  "bulk.csvDuplicates": "{{count}} duplicate{{plural}} skipped",
  "bulk.csvNoPhone": "{{count}} row{{plural}} missing phone",
  "bulk.csvNoNew": "No new contacts added.",
  "bulk.csvInvalidType": "Invalid file type. Please upload a .csv file.",
  "bulk.csvTooLarge": "File is too large ({{size}}MB). Maximum size is 5MB.",
  "bulk.csvReadError": "Failed to read the file. Make sure it's a valid CSV file.",
  "bulk.csvNoData": "No valid data rows found in the file.",
  "bulk.csvNoHeaders": "No valid headers found.",
  "bulk.csvHeadersOnly": "File has headers only — no data rows found.",
  "bulk.csvColumnMismatch": "Row {{row}}: expected {{expected}} columns, got {{got}}. Row skipped.",
  "bulk.csvEmpty": "File is empty.",
  "bulk.pagination": "{{start}}-{{end}} of {{total}}",
  "bulk.scheduleTimeFuture": "Scheduled time must be in the future.",
  "bulk.failedToSend": "Failed to send message",
  "bulk.switchFixedDelay": "Switch to Fixed delay",
  "bulk.switchRandomDelay": "Switch to Random delay",
  "bulk.switchSendNow": "Switch to Send Now",
  "bulk.switchSchedule": "Enable Schedule Send",
  "bulk.cancelSchedule": "Cancel schedule",
  "bulk.stopSendingTooltip": "Stop sending",
  "bulk.mobileRecipients": "{{{count}}} contacts - {{{status}}}",
  "bulk.statusPending": "Pending",
  "bulk.statusSent": "Sent",
  "bulk.statusFailed": "Failed",

  // MessageBubble
  "msg.photo": "Photo",
  "msg.video": "Video",
  "msg.audio": "Audio",
  "msg.voiceMessage": "Voice message",
  "msg.document": "Document",
  "msg.location": "Location",
  "msg.sticker": "Sticker",
  "msg.contact": "Contact",
  "msg.link": "Link",
  "msg.deleted": "This message was deleted",
  "msg.you": "You",
  "msg.loadingImage": "Loading image...",
  "msg.imageUnavailable": "Image unavailable",
  "msg.image": "Image",
  "msg.loadingVideo": "Loading video...",
  "msg.videoUnavailable": "Video unavailable",
  "msg.tapToOpenMap": "Tap to open map",
  "msg.openInMaps": "Open in Maps",
  "msg.file": "File",
  "msg.documentType": "Document",
  "msg.voiceCall": "Voice Call",
  "msg.videoCall": "Video Call",
  "msg.tapToCallBack": "Tap to call back",
  "msg.contactCard": "Contact card",
  "msg.transcriptionFailed": "Failed to transcribe audio",
  "msg.decryptFailed": "Could not download audio clip for transcription",
  "msg.viewTranscript": "View Transcript",

  // MessageActions
  "actions.reply": "Reply",
  "actions.aiReply": "Suggest Reply",
  "actions.generatingSuggestion": "Generating suggestion...",
  "actions.sendNow": "Send Now",
  "actions.insertInEditor": "Edit in Composer",
  "actions.transcribe": "Transcribe",
  "actions.copy": "Copy",
  "actions.react": "React",
  "actions.cancel": "Cancel",

  // AttachmentMenu
  "attach.aiAssistant": "AI Message Composer",
  "attach.image": "Image",
  "attach.document": "Document",
  "attach.location": "Location",
  "attach.link": "Link",

  // VoiceRecorder
  "voice.delete": "Delete",
  "voice.connecting": "Connecting...",
  "voice.resume": "Resume",
  "voice.pause": "Pause",
  "voice.send": "Send",

  // ReplyPreview
  "reply.replyTo": "Reply to",

  // CsvProductImporter
  "csvImporter.title": "Import Products via CSV",
  "csvImporter.subtitle": "Bulk import products into your knowledge base",
  "csvImporter.expectedColumns": "Expected CSV Columns",
  "csvImporter.column": "Column",
  "csvImporter.required": "Required",
  "csvImporter.optional": "Optional",
  "csvImporter.example": "Example",
  "csvImporter.requiredBadge": "Required",
  "csvImporter.optionalBadge": "Optional",
  "csvImporter.validationTitle": "Validation Rules",
  "csvImporter.valRequired": "Product Name and Product Description are <strong>required</strong> — rows missing them will be skipped",
  "csvImporter.valEmptyRows": "Empty rows are automatically ignored",
  "csvImporter.valPrice": "Price must be a valid number (e.g., 299.99)",
  "csvImporter.valDuplicates": "Duplicate products (by name) are detected and skipped",
  "csvImporter.valEncoding": "Supports UTF-8 encoding for Arabic and other languages",
  "csvImporter.valTrim": "All leading/trailing whitespace is trimmed from every field",
  "csvImporter.downloadTemplate": "Download sample CSV template",
  "csvImporter.dropHere": "Drop your file here",
  "csvImporter.clickToUpload": "Click to upload or drag & drop",
  "csvImporter.csvOnly": "CSV files only, UTF-8 encoding recommended",
  "csvImporter.processing": "Processing your CSV file...",
  "csvImporter.validating": "Validating data and checking for errors",
  "csvImporter.rowsRead": "Rows Read",
  "csvImporter.imported": "Imported",
  "csvImporter.failed": "Failed",
  "csvImporter.errorsTitle": "Import Errors ({{count}})",
  "csvImporter.fileError": "File",
  "csvImporter.rowError": "Row {{row}}",
  "csvImporter.readyTitle": "Products Ready to Import ({{count}})",
  "csvImporter.uploadAnother": "Upload Another File",
  "csvImporter.cancel": "Cancel",
  "csvImporter.importBtn": "Import {{count}} Product{{plural}}",
  "csvImporter.invalidFileType": "Invalid file type. Please upload a .csv file.",
  "csvImporter.noHeaderColumns": "No recognized product columns found in the header. Please check the column names.",
  "csvImporter.missingRequiredCols": "The CSV must include at least 'Product Name' and 'Product Description' columns.",
  "csvImporter.missingName": "Product Name is required and is missing.",
  "csvImporter.missingDesc": "\"{{name}}\" is missing a Product Description, which is required.",
  "csvImporter.invalidPrice": "\"{{name}}\" has an invalid price: \"{{price}}\". Must be a valid number.",
  "csvImporter.duplicate": "\"{{name}}\" already exists in your product list. Duplicate skipped.",
  "csvImporter.dupInCsv": "\"{{name}}\" appears multiple times in the CSV. Duplicate skipped.",
  "csvImporter.readFailed": "Failed to read the file. Please ensure it is a valid UTF-8 CSV file.",

  // Charts
  "charts.usageTrends": "Usage Trends",
  "charts.last30Days": "Last 30 days · tokens & messages",
  "charts.tokens": "Tokens",
  "charts.messages": "Messages",
  "charts.input": "Input",
  "charts.output": "Output",
  "charts.tokenSplit": "Token Split",
  "charts.inputVsOutput": "Input vs Output distribution",
  "charts.inputRatio": "Input ratio",
  "charts.planCapacity": "Plan Capacity",
  "charts.usageVsLimits": "Usage vs limits per feature",
  "charts.used": "used",
  "charts.dailyActivity": "Daily Activity",
  "charts.inputOutputPerDay": "Input & output tokens per day",
  "charts.activityCalendar": "Activity Calendar",
  "charts.activitySubtitle": "{{messages}} messages · {{days}} active days · last 4 weeks",
  "charts.less": "Less",
  "charts.more": "More",
  "charts.buildingHistory": "Building your activity history",
  "charts.buildingHistoryDesc": "Data accumulates each time you visit the dashboard. Come back tomorrow to see your first trend!",
  "charts.activeDays": "Active Days",
  "charts.of28": "{{days}} of 28",
  "charts.avgDaily": "Avg Daily",
  "charts.avgDailyMsgs": "{{msgs}} msgs",
  "charts.system": "System",
  "charts.inputPrompts": "Input Prompts",
  "charts.aiOutput": "AI Output",
  "charts.systemContext": "System & Context",
  "charts.avgHandleTime": "Average Handle Time",
  "charts.minute": "min",
  "charts.vsLastWeek": "vs. last week",
  "charts.activitiesCount": "{{count}} acts",

  // Plan Usage
  "planUsage.messagesUsage": "Messages",
  "planUsage.used": "Used",
  "planUsage.upgradePlan": "Upgrade Plan",
  "planUsage.consumed": "Used",
  "planUsage.remaining": "Remaining",
  "planUsage.available": "Available",

  // Workflows
  "workflows.smartReplyUpdated": "Smart reply settings updated successfully",
  "workflows.reengageDesc": "Auto re-engage inactive customers & recover sales",
  "workflows.sentThisWeek": "{{count}} follow-ups sent this week",
  "workflows.sentTotal": "{{count}} follow-ups sent in total",
  "workflows.activeMonitoring": "Active & monitoring",
  "workflows.queuedPending": "({{count}} queued)",

  // Copilot Assistant
  "copilot.action.launchCampaign": "Launch Campaign",
  "copilot.action.startCampaign": "Launch Campaign",
  "copilot.action.chats": "Chats",
  "copilot.action.checkChats": "Check Chats",
  "copilot.action.knowledge": "Knowledge Base",
  "copilot.action.blacklist": "Blacklist",
  "copilot.action.automation": "Automation",
  "copilot.action.upgradePlan": "Upgrade Plan",
  "copilot.response.suggest": "You can launch a bulk broadcast campaign upload training documents to knowledge base or check live chats",
  "copilot.response.howAreYou": "I am doing great and ready to help what would you like to do today",
  "copilot.response.greeting": "Hello ready to assist you with anything in Wyzon dashboard",
  "copilot.response.thanks": "You are welcome always happy to help",
  "copilot.response.quota": "You have {{remaining}} messages remaining out of {{total}} on {{plan}} plan",
  "copilot.response.whatsappConnected": "WhatsApp is connected and actively running",
  "copilot.response.whatsappIdle": "WhatsApp is currently idle please scan QR code",
  "copilot.response.fallback": "You have {{remaining}} messages remaining and WhatsApp is active how can I help you",

  // Copilot Engine
  "copilotEngine.howCanIHelp": "How can I help you?",
  "copilotEngine.greetingHi": "Hi {{name}} {{message}}",
  "copilotEngine.greetingHello": "Hello {{name}} {{message}}",
  "copilotEngine.preparedReplies": "Prepared reply options for {{name}}",
  "copilotEngine.navigatingTab": "Navigating to {{tab}}",
  "copilotEngine.openingCampaign": "Opening campaign wizard",
  "copilotEngine.automationEnabled": "Automation has been turned on",
  "copilotEngine.automationDisabled": "Automation has been paused",
  "copilotEngine.mediaReplyEnabled": "{{mediaType}} replies have been enabled",
  "copilotEngine.mediaReplyDisabled": "{{mediaType}} replies have been disabled",
  "copilotEngine.followupEnabled": "Auto followup has been enabled",
  "copilotEngine.followupDisabled": "Auto followup has been disabled",
  "copilotEngine.blacklistAdded": "Number {{phone}} added to blacklist",
  "copilotEngine.blacklistRemoved": "Number {{phone}} removed from blacklist",
  "copilotEngine.processError": "An error occurred while processing command",

  // CRM Pipeline
  "crm.title": "CRM Pipeline",
  "crm.tracked": "tracked",
  "crm.all": "All",
  "crm.noChats": "No chats loaded. Switch to WhatsApp tab to load conversations first.",
  "crm.untracked": "Not tracked",
  "crm.moveTo": "Move to stage",
  "crm.tags": "Tags",
  "crm.manageStage": "Manage Stage",
  "crm.addToLeadNew": "Add as Lead New",
  "crm.emptyStage": "No contacts in this stage yet",
  "crm.setupTitle": "CRM Pipeline Setup",
  "crm.setupDesc": "Create WhatsApp labels to track your leads through the sales pipeline — from new lead to closed customer. This is a one-time setup.",
  "crm.settingUp": "Setting up...",
  "crm.setupBtn": "Setup Pipeline Labels",
  "crm.confirmSetup": "Create Pipeline Labels?",
  "crm.confirmSetupDesc": "This will create {{count}} labels on your WhatsApp session: Lead New, In Contact, Negotiating, Customer, Lost — plus VIP and Complaint tags.",
  "crm.cancel": "Cancel",
  "crm.createLabels": "Create Labels",
  "crm.refreshLabels": "Refresh Labels",
  "crm.reset": "Reset",
  "crm.resetTitle": "Reset Pipeline?",
  "crm.resetDesc": "This will delete ALL CRM labels from WhatsApp and clear your local tracking data. This action cannot be undone.",
  "crm.confirmReset": "Delete All Labels",
  "crm.stage.leadnew": "Lead New",
  "crm.stage.incontact": "In Contact",
  "crm.stage.negotiating": "Negotiating",
  "crm.stage.customer": "Customer",
  "crm.stage.lost": "Lost",
  "crm.addCustomer": "Add Customer",
  "crm.addCustomerTitle": "Add New Customer",
  "crm.addCustomerDesc": "Add a customer that hasn't messaged yet to track them in the Pipeline.",
  "crm.countryCodeLabel": "Country Code",
  "crm.phoneLabel": "Phone Number",
  "crm.phonePlaceholder": "201234567890",
  "crm.digitsLeft": "{{count}} digits left",
  "crm.digitsLeftOne": "1 digit left",
  "crm.enterMoreDigits": "Enter {{count}} more digits",
  "crm.enterMoreDigitsOne": "Enter 1 more digit",
  "crm.phoneValid": "✓",
  "crm.nameLabel": "Customer Name",
  "crm.namePlaceholder": "Enter customer name",
  "crm.stageLabel": "Initial Stage",
  "crm.whatsappLabel": "WhatsApp Label",
  "crm.addBtn": "Add to Pipeline",
  "crm.addBtnSimple": "Add",
  "crm.adding": "Adding...",
  "crm.invalidPhone": "Enter a valid phone number ({{digits}} digits)",
  "crm.alreadyExists": "This number already exists in your chat list",
  "crm.manualEntry": "Manual Entry",
  "crm.importCsv": "Import CSV",
  "crm.importCsvTitle": "Import Customers from CSV",
  "crm.importCsvDesc": "Upload a CSV file with customer data to batch-add them to the Pipeline.",
  "crm.importCsvColumns": "Supported Columns",
  "crm.importCsvColumnPhone": "Phone (required)",
  "crm.importCsvColumnName": "Name (optional)",
  "crm.importCsvColumnStage": "Stage (optional)",
  "crm.importCsvStageDefault": "Default: Lead New",
  "crm.importCsvStageOptions": "Available options",
  "crm.importCsvDownloadTemplate": "Download CSV Template",
  "crm.importCsvDropHere": "Drop file here or click to upload",
  "crm.importCsvCsvOnly": "CSV files only",
  "crm.importCsvPreviewTitle": "Preview ({{count}} customer{{plural}})",
  "crm.importCsvNoValid": "No valid data found in file. Make sure there's a phone column.",
  "crm.importCsvWillImport": "Will import {{count}} customer{{plural}}",
  "crm.importCsvDuplicatesSkipped": "{{count}} duplicate{{plural}} skipped",
  "crm.importCsvInvalidFile": "Invalid file type. Please upload a .csv file.",
  "crm.importCsvReadError": "Failed to read file. Make sure it's a valid CSV.",
  "crm.importCsvBtn": "Import {{count}} Customer{{plural}}",
  "crm.importCsvEmpty": "File is empty or contains no valid data.",

  // Catalog
  "catalog.title": "Catalog Manager",
  "catalog.products": "products",
  "catalog.cart": "Cart",
  "catalog.enableCart": "Enable Cart",
  "catalog.disableCart": "Disable Cart",
  "catalog.refresh": "Refresh",
  "catalog.tabProducts": "Products",
  "catalog.tabCollections": "Collections",
  "catalog.searchProducts": "Search products...",
  "catalog.allProducts": "All Products",
  "catalog.addProduct": "Add Product",
  "catalog.noProducts": "No products in catalog yet",
  "catalog.addFirstProduct": "Add your first product to start selling",
  "catalog.noSearchResults": "No matching results",
  "catalog.noImage": "No image",
  "catalog.hidden": "Hidden",
  "catalog.edit": "Edit",
  "catalog.show": "Show",
  "catalog.hide": "Hide",
  "catalog.delete": "Delete",
  "catalog.editProduct": "Edit Product",
  "catalog.addProductBtn": "Add",
  "catalog.productName": "Product Name",
  "catalog.productNamePlaceholder": "e.g. Wireless Bluetooth Pro",
  "catalog.replaceImage": "Replace Image",
  "catalog.productImage": "Product Image",
  "catalog.clickToUpload": "Click to upload",
  "catalog.leaveEmptyToKeep": "Leave empty to keep current image",
  "catalog.description": "Description",
  "catalog.descriptionPlaceholder": "Product description",
  "catalog.price": "Price",
  "catalog.pricePlaceholder": "e.g. 299.99",
  "catalog.currency": "Currency",
  "catalog.productUrl": "Product URL",
  "catalog.productUrlPlaceholder": "https://example.com/product",
  "catalog.retailerId": "Retailer ID (SKU)",
  "catalog.retailerIdPlaceholder": "SKU001",
  "catalog.cancel": "Cancel",
  "catalog.saveChanges": "Save Changes",
  "catalog.productAdded": "Product added successfully",
  "catalog.productAddFailed": "Failed to add product",
  "catalog.productUpdated": "Product updated",
  "catalog.productUpdateFailed": "Failed to update product",
  "catalog.productDeleted": "Product deleted",
  "catalog.productDeleteFailed": "Failed to delete product",
  "catalog.productShown": "Product shown",
  "catalog.productHidden": "Product hidden",
  "catalog.visibilityFailed": "Failed to change visibility",
  "catalog.confirmDeleteProduct": "Delete Product?",
  "catalog.confirmDeleteCollection": "Delete Collection?",
  "catalog.cannotUndo": "This action cannot be undone.",
  "catalog.confirmDelete": "Confirm Delete",
  "catalog.collectionCount": "{{count}} collection",
  "catalog.createCollection": "Create Collection",
  "catalog.noCollections": "No collections yet",
  "catalog.createFirstCollection": "Create a collection to organize your products",
  "catalog.collectionName": "Collection Name",
  "catalog.collectionNamePlaceholder": "e.g. Electronics",
  "catalog.selectProducts": "Select Products",
  "catalog.noProductsForCollection": "No products available",
  "catalog.createCollectionBtn": "Create",
  "catalog.collectionCreated": "Collection created",
  "catalog.collectionCreateFailed": "Failed to create collection",
  "catalog.collectionUpdated": "Collection updated",
  "catalog.collectionUpdateFailed": "Failed to update collection",
  "catalog.collectionDeleted": "Collection deleted",
  "catalog.collectionDeleteFailed": "Failed to delete collection",
  "catalog.productsInCollection": "{{count}} product",
  "catalog.editCollection": "Edit Collection",
  "catalog.cartToggleFailed": "Failed to toggle cart",
  "bulk.sendingActive": "Active Bulk Campaign",
  "bulk.campaignScheduledShort": "Scheduled Send",
  "bulk.scheduledFor": "Scheduled for",
  "bulk.view": "View",
  "bulk.stopCampaign": "Stop",
  "bulk.sendingProgress": "Progress",

  // Bookings & Leads
  "bookings.title": "AI Bookings & Orders",
  "bookings.subtitle": "Track and confirm appointments and orders captured automatically from WhatsApp",
  "bookings.export": "Export",
  "bookings.add": "Add",
  "bookings.save": "Save",
  "bookings.cancel": "Cancel",
  "bookings.confirm": "Confirm",
  "bookings.complete": "Complete",
  "bookings.delete": "Delete",
  "bookings.back": "Back",
  "bookings.status.pending": "Pending",
  "bookings.status.confirmed": "Confirmed",
  "bookings.status.completed": "Completed",
  "bookings.status.cancelled": "Cancelled",
  "bookings.type.booking": "Appointment",
  "bookings.type.order": "Order",
  "bookings.type.consultation": "Consultation",
  "bookings.type.inquiry": "Inquiry",
  "bookings.tracked": "tracked",
  "bookings.addBooking": "Add Booking",
  "bookings.exportCsv": "Export CSV",
  "bookings.refresh": "Refresh",
  "bookings.all": "All",
  "bookings.loading": "Loading bookings...",
  "bookings.empty": "No bookings recorded yet",
  "bookings.emptyDesc": "AI automatically detects and logs booking requests and customer orders from WhatsApp chats.",
  "bookings.notes": "Notes: ",
  "bookings.chat": "Chat",
  "bookings.modalTitle": "New Booking / Lead",
  "bookings.customerName": "Customer Name",
  "bookings.customerNamePlaceholder": "e.g. John Doe",
  "bookings.phoneLabel": "Phone Number *",
  "bookings.typeLabel": "Type",
  "bookings.statusLabel": "Status",
  "bookings.serviceLabel": "Service or Item",
  "bookings.servicePlaceholder": "e.g. Dental Checkup",
  "bookings.dateLabel": "Date",
  "bookings.timeLabel": "Time",
  "bookings.notesLabel": "Notes",
  "bookings.notesPlaceholder": "Special notes...",

  // Dashboard V2 Master Redesign
  "v2.askTitle": "Hello, What's on mind?",
  "v2.askSubtitle": "Ask your AI assistant...",
  "v2.askPlaceholder": "Ask AI assistant anything about your chats, campaigns, or metrics...",
  "v2.linkedAccount": "Linked WhatsApp Session",
  "v2.planMessagesLimit": "Messages Limit",
  "v2.monthlyPlanFee": "Monthly regular fee",
  "v2.editLimits": "Edit plan limitation",
  "v2.receiveAction": "Receive",
  "v2.sendAction": "Send",
  "v2.totalMessages": "Total Messages",
  "v2.aiTokens": "AI Tokens Processed",
  "v2.viewChart": "View on chart mode",
  "v2.weekly": "Weekly",
  "v2.monthly": "Monthly",
  "v2.allTime": "All Time",
  "v2.systemLock": "AI Auto-Pilot",
  "v2.autoPilotActive": "AI Auto-Pilot: Active (Unlocked)",
  "v2.autoPilotPaused": "AI Auto-Pilot: Paused (Locked)",
  "v2.aiEnabled": "Enabled",
  "v2.aiDisabled": "Disabled",
  "v2.aiUsage": "AI Usage",
  "v2.resolutionRate": "Resolution rate",
  "v2.planDays": "Days",
  "v2.planHours": "109 hours, 23 minutes",
  "v2.liveEngagement": "AI Response Volume",
  "v2.extendedTraffic": "Smart Replies & Flows",
  "v2.mainStocks": "AI Response Volume",
  "v2.extendedLimited": "Smart Replies & Flows",
  "v2.responseSpeed": "Response Speed",
  "v2.instantLatency": "Instant AI Latency",
  "v2.manualSpeed": "Manual 4.2m",
  "v2.aiSpeed": "0.8s AI",
  "v2.speedImprovement": "+98% Faster",
  "v2.activityManager": "Activity manager",
  "v2.businessPlans": "Automation workflows",
  "v2.customerSupport": "Customer Support",
  "v2.salesOrders": "Sales & Orders",
  "v2.appointmentBooking": "Booking & Leads",
  "v2.walletVerification": "Webhook AI Guard",
  "v2.enableVerification": "Enable real-time verification to secure incoming webhook.",
  "v2.reviewRating": "Review rating",
  "v2.feedbackQuestion": "How is your business\nmanagement going?",
  "v2.antiBanProtectionActive": "Anti-Ban Protection Active",
  "v2.whatsappNumberHealth": "WhatsApp Number Health",
  "v2.autoRepliesTitle": "AI Auto-Replies",
  "v2.weeklyEngagementGrowth": "Weekly Engagement Growth",
  "v2.planTimeRemaining": "{{hours}} hours, {{minutes}} minutes",
  "v2.planCycle": "Plan Cycle",
  "v2.startRenewalTimeline": "Start & Renewal Timeline",
  "v2.aiRepliesTrend": "AI Replies Trend",
  "v2.healthLevel1.label": "Critical Risk",
  "v2.healthLevel1.desc": "High burst rate · Zero replies",
  "v2.healthLevel1.actionHint": "Auto-cooldown activated",
  "v2.healthLevel2.label": "At Risk",
  "v2.healthLevel2.desc": "Identical message templates",
  "v2.healthLevel2.actionHint": "Enable text randomization",
  "v2.healthLevel3.label": "Moderate",
  "v2.healthLevel3.desc": "Reply rate at 14%",
  "v2.healthLevel3.actionHint": "Increase delays to 18s",
  "v2.healthLevel4.label": "Good & Safe",
  "v2.healthLevel4.desc": "Random delays compliant",
  "v2.healthLevel4.actionHint": "Running at safe speed",
  "v2.healthLevel5.label": "Optimal Safety",
  "v2.healthLevel5.desc": "High reply rate · Anti-ban active",
  "v2.healthLevel5.actionHint": "Maximum trust & reputation",
  "v2.whatsapp": "WhatsApp",
  "v2.planName.enterprise": "Enterprise",
  "v2.planName.pro": "Pro",
  "v2.planName.basic": "Basic",
  "v2.activityManagerTitle": "Activity manager",
  "v2.voiceNotes": "Voice Notes",
  "v2.smartMedia": "Smart Media",
  "v2.documents": "Documents",
  "v2.dripFollowup": "Drip Follow-ups",
  "v2.thisWeek": "this week",
  "v2.chatsUnit": "Chats",
  "v2.activeWhatsAppChats": "Active WhatsApp Chats",
  "v2.liveChatPulse": "Live Chat Pulse",
  "v2.aiReplyModes": "AI Reply Modes",
  "v2.voiceNotesTimelineTitle": "AI Voice Notes",
  "v2.voiceNotesTimelineDesc": "Text to natural voice",
  "v2.mediaTimelineTitle": "Smart Media & Images",
  "v2.mediaTimelineDesc": "Auto-send media files",
  "v2.documentsTimelineTitle": "Documents & Catalogs",
  "v2.documentsTimelineDesc": "Auto-send catalog guides",

  // Knowledge Base Tabs & AI Actions
  "kb.tabs.content": "Facility Content & Catalog",
  "kb.tabs.actions": "AI Actions & API Tools",
  "actions.bannerBadge": "AI Function Calling",
  "actions.bannerTitle": "Dynamic API Actions & External Tool Integrations",
  "actions.bannerDesc": "Empower your AI with real-time tools like order tracking, loyalty point checks, and ERP inventory lookups via live API endpoints or MCP with encrypted secret headers.",
  "actions.addNewTool": "Create AI Action",
  "actions.libraryTitle": "1-Click Ready Templates",
  "actions.useTemplate": "Use Template",
  "actions.activeToolsTitle": "Configured AI Actions",
  "actions.toolsCount": "Tools",
  "actions.emptyTitle": "No AI Actions Configured",
  "actions.emptyDesc": "Add a new tool or choose a preset above to enable live data lookups & actions during customer chats.",
  "actions.paramsLabel": "Args:",
  "actions.testToolBtn": "Test Tool",
  "actions.deleteConfirm": "Are you sure you want to delete this tool?",
  "actions.deletedSuccess": "Tool deleted successfully.",
  "actions.savedSuccess": "Tool saved and synced with AI Assistant!",
  "actions.presetApplied": "Preset tool added successfully!",
  "actions.editActionTitle": "Edit AI Action / Tool",
  "actions.newActionTitle": "Configure New AI Action (Tool Calling)",
  "actions.modalSubtitle": "Empower the AI Assistant to securely execute live HTTP requests on your behalf",
  "actions.quickPresets": "Templates:",
  "actions.tabs.basic": "Endpoint & Info",
  "actions.tabs.parameters": "AI Parameters",
  "actions.tabs.authHeaders": "Headers & Secrets",
  "actions.tabs.bodyPayload": "JSON Body",
  "actions.fields.toolName": "Tool Identifier (Function Name) *",
  "actions.fields.toolNameHint": "Used by AI Assistant (lowercase with underscores, e.g. track_order)",
  "actions.fields.status": "Status",
  "actions.statusActive": "Active",
  "actions.statusDisabled": "Disabled",
  "actions.fields.toolDesc": "AI Decision Prompt & Description *",
  "actions.fields.toolDescPlaceholder": "e.g. Inquire about shipment status, location and delivery date using order ID",
  "actions.fields.toolDescHint": "Explain clearly when and why the AI Assistant should trigger this tool",
  "actions.fields.endpointUrl": "HTTP Method & Endpoint URL *",
  "actions.fields.urlHint": "Supports dynamic templates like {{order_id}} or {{customer_phone}}",
  "actions.params.title": "Parameters Extracted by AI Assistant",
  "actions.params.desc": "Define the arguments the AI Assistant will extract from the customer's chat.",
  "actions.params.addParam": "Add Parameter",
  "actions.params.paramName": "Param Name",
  "actions.params.paramType": "Type",
  "actions.params.paramLocation": "Pass In",
  "actions.params.locQuery": "Query (?param=)",
  "actions.params.locPath": "Path (/:param)",
  "actions.params.locBody": "Body (JSON)",
  "actions.params.locHeader": "Header",
  "actions.params.description": "Description for AI",
  "actions.params.descPlaceholder": "The order ID mentioned by the customer",
  "actions.params.defaultOrderIdDesc": "Order ID",
  "actions.params.required": "Required",
  "actions.headers.title": "HTTP Headers & Secret Keys",
  "actions.headers.desc": "API keys and Bearer tokens are kept secret and never exposed to the AI.",
  "actions.headers.addHeader": "Add Header",
  "actions.body.title": "Request JSON Body Template",
  "actions.body.desc": "Insert dynamic tags like {{order_id}} or {{customer_phone}}",
  "actions.validation.nameRequired": "Tool identifier name is required.",
  "actions.validation.descRequired": "Tool description is required so the AI Assistant knows when to trigger it.",
  "actions.validation.urlRequired": "Target API URL endpoint is required.",
  "actions.testToolTitle": "Test AI Tool Live",
  "actions.testParameters": "Tool Arguments / Parameters",
  "actions.noParamsRequired": "This tool requires no parameters.",
  "actions.executing": "Executing Tool Request...",
  "actions.runTestNow": "Execute Test Request",
  "actions.toolOutput": "Tool Execution Result",
  "actions.aiIntegrationNote": "How AI Uses This Result:",
  "actions.aiExplanation": "The AI parses this live JSON response and crafts a natural, friendly response directly to the customer on WhatsApp without exposing internal URLs or tokens.",

  // Branches & Locations
  "kb.tabs.branches": "Branches & Locations",
  "branches.title": "Branches",
  "branches.newBranch": "New Branch",
  "branches.editBranch": "Edit Branch",
  "branches.configureLocation": "Configure Location",
  "branches.addBranch": "Add New Branch",
  "branches.searchPlaceholder": "Search branches...",
  "branches.noBranches": "No branches configured yet.",
  "branches.selectBranchTitle": "Select a Branch or Add New",
  "branches.selectBranchDesc": "Manage your branches with Google Maps links to auto-match nearest branch on WhatsApp.",
  "branches.fields.name": "Branch Name *",
  "branches.fields.namePlaceholder": "e.g. New Cairo Branch",
  "branches.fields.status": "Branch Status",
  "branches.statusActive": "Active",
  "branches.statusDisabled": "Disabled",
  "branches.fields.mapLink": "Google Maps Link *",
  "branches.fields.mapLinkPlaceholder": "https://maps.app.goo.gl/... or https://google.com/maps/...",
  "branches.toggleDisable": "Active (click to disable)",
  "branches.toggleEnable": "Disabled (click to enable)",
  "branches.useCurrentGps": "📍 Use Current GPS",
  "branches.detectingGps": "Detecting...",
  "branches.resolvingUrl": "Resolving coordinates from link...",
  "branches.fields.address": "Detailed Address / Landmarks",
  "branches.fields.addressPlaceholder": "e.g. 90th St, Next to City Center",
  "branches.fields.hours": "Working Hours",
  "branches.fields.hoursPlaceholder": "e.g. 10:00 AM - 11:00 PM",
  "branches.fields.phone": "Phone Number",
  "branches.liveMapPreview": "Live Map Preview",
  "branches.openInMaps": "Open in Maps",
  "branches.mapPlaceholder": "Enter Google Maps link to preview location here",
  "branches.enableDelivery": "Enable Delivery & Fee Engine for this branch",
  "branches.maxRadius": "Max Radius (km)",
  "branches.baseFee": "Base Delivery Fee",
  "branches.feePerKm": "Fee per km",
  "branches.savedSuccess": "Branch saved successfully",
  "branches.deletedSuccess": "Branch deleted successfully",
  "branches.deleteConfirm": "Are you sure you want to delete this branch?",
  "branches.validation.nameRequired": "Branch name is required",
  "branches.validation.locationRequired": "Valid location is required",
  "branches.validation.saveFailed": "Failed to save branch",

  // AI Voice Copilot
  "copilot.sendWhatsAppMessage": "Send WhatsApp message",
  "copilot.sendTo": "Send to",
  "copilot.confirmAndSend": "Confirm & Send",
  "copilot.cancel": "Cancel",
  "copilot.sending": "Sending...",
  "copilot.sentSuccessfully": "Sent successfully",
  "copilot.sendFailed": "Failed to send",
  "copilot.processing": "Processing command...",
  "copilot.messagePlaceholder": "Type message content here...",
  "copilot.readyToSend": "Ready to send message to {{name}}",
  "copilot.navigatedTo": "Navigated to {{tab}}",
  "copilot.openingCampaign": "Opening campaign wizard",
  "copilot.smartOptions": "3 AI Smart reply options (Click to select & edit):",
  "copilot.sendThisReply": "Send this reply now",
  "copilot.startInternalThread": "Start internal thread",

  // Platforms & Channel Hubs
  "platforms.all": "All",
  "platforms.allChats": "All chats",
  "platforms.whatsapp": "WhatsApp",
  "platforms.facebook": "Facebook",
  "platforms.instagram": "Instagram",
  "platforms.connected": "Connected",
  "platforms.waitingQr": "Waiting for QR",
  "platforms.disconnected": "Disconnected",

  // Bulk channel tags
  "bulk.channelInstagram": "Instagram",

  // Instagram Hub & Direct Messages
  "instagram.connectTitle": "Connect Instagram Business",
  "instagram.connectDesc": "Connect your Instagram Professional or Business account to manage customer DMs, reply with AI, and run campaigns.",
  "instagram.autoDetectTab": "Auto-Detect via Facebook",
  "instagram.manualTab": "Direct Manual Setup",
  "instagram.connectedAccount": "Connected Instagram Account",
  "instagram.active": "Active",
  "instagram.messagesReady": "Send & Receive Messages:",
  "instagram.aiResponses": "Smart AI Responses:",
  "instagram.disconnect": "Disconnect Account",
  "instagram.fbNotConnected": "Facebook Page Not Connected",
  "instagram.fbNotConnectedDesc": "To auto-detect, please connect your linked Facebook Page first, or use the 'Direct Manual Setup' tab.",
  "instagram.detecting": "Scanning for linked Instagram Business account...",
  "instagram.detectedReady": "Instagram account found! You can connect it now using your page authorization.",
  "instagram.connectNow": "Connect This Account Now",
  "instagram.noAccountFound": "No Instagram Business account was found linked to this Facebook Page.",
  "instagram.requirementsTitle": "Prerequisites for Instagram connection:",
  "instagram.req1": "Account must be Professional (Business or Creator).",
  "instagram.req2": "Account must be linked to your Facebook Page in Page Settings.",
  "instagram.req3": "Enable 'Allow Access to Messages in Connected Tools' in Instagram app settings.",
  "instagram.accountIdLabel": "Instagram Account ID",
  "instagram.tokenLabel": "Page or User Access Token",
  "instagram.connectManualSubmit": "Verify & Connect",
  "instagram.connectedSuccess": "Instagram account connected successfully!",
  "instagram.requiredFields": "Please provide both Account ID and Access Token.",
  "instagram.defaultUser": "Instagram User",
  "instagram.noLinkedAccount": "No Instagram Business account linked to this Facebook Page. Please link it in Page Settings.",

  "facebook.messengerInbox": "Messenger Inbox",
  "facebook.messengerSub": "Facebook Messenger",
  "facebook.messengerNotConnectedTitle": "Messenger is Not Connected",
  "facebook.messengerNotConnectedDesc": "Please connect your official Facebook Page by entering your Page ID and Access Token in the form to activate messaging.",
  "facebook.integrationTitle": "Official Meta Integration",
  "facebook.readyToConnect": "Ready to connect",
  "facebook.credentialsTitle": "Meta Page Credentials",
  "facebook.credentialsDesc": "Enter your Page ID and Long-lived Access Token to connect Messenger and comment webhooks.",
  "facebook.pageNameLabel": "Page Name",
  "facebook.pageNamePlaceholder": "e.g. My Facebook Page",
  "facebook.pageIdLabel": "Page ID *",
  "facebook.accessTokenLabel": "Page Access Token *",
  "facebook.connectBtn": "Connect & Verify Page",
  "facebook.verifyingBtn": "Verifying...",
  "facebook.disconnectBtn": "Disconnect",
  "facebook.disconnectConfirm": "Are you sure you want to disconnect Facebook?",
  "facebook.validation.pageId": "Please enter Page ID",
  "facebook.validation.accessToken": "Please enter Page Access Token",
  "facebook.defaultPageName": "Facebook Page",
  "facebook.messengerActive": "Messenger Active",
  "facebook.searchPlaceholder": "Search Messenger chats...",
  "facebook.noMessagesTitle": "No messages yet",
  "facebook.noMessagesDesc": "Incoming customer messages from Messenger or post comments will automatically appear here.",
  "facebook.selectChatTitle": "Facebook Messenger",
  "facebook.selectChatDesc": "Select a conversation from the sidebar to view message history and send replies.",
  "facebook.aiReplyOn": "AI Auto Reply ON",
  "facebook.aiReplyOff": "AI OFF",
  "facebook.noHistory": "No previous messages in this chat.",
  "facebook.aiBadge": "AI Response",
  "facebook.typeReplyPlaceholder": "Type a Messenger reply...",
  "facebook.sendBtn": "Send",
  "facebook.justNow": "Just now",
  "facebook.webhookSuccess": "Page verified & Webhooks subscribed to messages and comments successfully!",
  "facebook.subscribedStatus": "Webhooks Active (Messages & Comments)",
  "facebook.loadingChats": "Loading Messenger conversations...",
  "facebook.refreshChats": "Refresh chats",
  "facebook.conversationsCount": "{{count}} conversations",
  "facebook.fetchError": "Failed to load conversations from Facebook",
  "facebook.retryBtn": "Retry",
  "facebook.anonymousUser": "Facebook User",
  "facebook.tokenExpired": "Meta Access Token has expired. The token used was temporary. Please update the token or use a permanent Never-Expiring System User Token.",
  "facebook.pageTokenRequired": "A Page Access Token is required instead of a User Token. Select your page from the User or Page dropdown in Graph API Explorer.",
  "facebook.connectionAlert": "Facebook Connection Alert",
  "facebook.reconnectBtn": "Update Token / Reconnect",
  "facebook.tokenLifespanNotice": "Important Token Lifespan Notice:",
  "facebook.tokenLifespanDesc": "Tokens generated from Graph API Explorer expire in 24 hours (causing HTTP 400). Use a permanent System User Token to avoid expiration.",
  "facebook.howToCreatePermanentToken": "How to create Never-Expire Token?",
  "facebook.hideGuide": "Hide Guide",
  "facebook.permanentGuideTitle": "Steps to generate a Never-Expiring Token:",
  "facebook.permanentGuideStep1": "Go to Meta Business Settings -> Users -> System Users.",
  "facebook.permanentGuideStep2": "Create an Admin System User, click Add Assets, select your Page and enable Full Control.",
  "facebook.permanentGuideStep3": "Click Generate New Token, select your app, and choose Expiration: Never.",
  "facebook.permanentGuideStep4": "Select required scopes (pages_messaging, pages_manage_metadata, pages_show_list, pages_read_engagement), copy the token and paste it here.",

  // Common Channel & Pipeline keys
  "channels.awaitingSetup": "Awaiting Setup",
  "channels.connectionError": "Connection Error",
  "channels.serverSaveError": "Failed to save connection on server.",
  "channels.paste": "Paste",
  "channels.pasted": "Pasted!",
  "channels.show": "Show",
  "channels.hide": "Hide",
  "channels.copy": "Copy",
  "channels.copied": "Copied",
  "channels.copyUrl": "Copy URL",
  "channels.copyToken": "Copy Token",
  "channels.copyFields": "Copy Fields",
  "channels.clickToCopyScope": "Click to copy scope",
  "channels.clickCodeToCopy": "Click code to copy",
  "channels.requiredBadge": "Required",
  "channels.commentsBadge": "Comments",
  "channels.contextBadge": "Context",
  "channels.pipelineTitle": "Permissions & Data Flow Pipeline",
  "channels.openMetaDevelopers": "Open Meta Developers Dashboard",
  "channels.stage1Title": "Payload Webhook Stream",
  "channels.stage2Title": "Route to Wyzon Endpoint",
  "channels.webhookConfigTitle": "Our Meta Webhook Configuration",
  "channels.webhookDataLines": "Webhook Setup Data Lines:",
  "channels.callbackUrlLabel": "Callback URL",
  "channels.verifyTokenLabel": "Verify Token",
  "channels.webhookFieldsLabel": "Webhook Subscription Fields",
  "channels.fieldsReadyBadge": "Fields ready for subscription",
  "channels.scopeFlowLines": "Scope Flow Lines & Data Streams:",
  "channels.gatewayFlowLines": "Scope Flow Lines & Gateway Streams:",
  "channels.outboundScopeFlowLines": "Scope Flow Lines & Outbound Dispatches:",
  "channels.outboundAiDecision": "AI Decision & Reply Engine",
  "channels.outboundTitle": "Autonomous Outbound Response",
  "channels.actionAndClosing": "Action & Closing",
  "channels.liveTraffic": "Live Traffic",
  "channels.triggerOnMeta": "Trigger on Meta",
  "channels.liveDispatch": "Live Dispatch",
  "channels.privateDmBadge": "Private DM",
  "channels.profileBadge": "Profile",

  // Instagram Hub & Service additions
  "instagram.connectHeaderTitle": "Connect Meta Instagram & Direct",
  "instagram.connectHeaderSubtitle": "Enter your Instagram Business Account ID and permanent Access Token to connect Direct chats, comments, and AI automation.",
  "instagram.accountNameLabel": "Instagram Account Name (Optional)",
  "instagram.accountNamePlaceholder": "e.g. @brand_official",
  "instagram.accountIdField": "Instagram Business Account ID",
  "instagram.numericIdOnly": "Numeric ID",
  "instagram.accessTokenField": "Page / Access Token",
  "instagram.tokenPlaceholderHint": "Long-lived Access Token starting with EAA... with required scopes shown in data flow.",
  "instagram.tokenSecurityHint": "Permanent access tokens are securely encrypted on Wyzon servers to prevent unauthorized access.",
  "instagram.verifyingConnecting": "Verifying Permissions & Connecting Account...",
  "instagram.verifyAndConnectBtn": "Verify & Connect Instagram Account",
  "instagram.pipelineDesc": "Interactive diagram linking Instagram permissions with live event pipelines between Meta and Wyzon",
  "instagram.inboundTitle": "Customer Inbound Interaction",
  "instagram.inboundDesc": "Starts when a customer sends an Instagram Direct message or posts a comment.",
  "instagram.scopeDirectDesc": "Direct Ingress: Stream incoming chats, audio & attachments",
  "instagram.scopeCommentsDesc": "Comments Stream: Ingest visitor comments & reactions on posts and reels",
  "instagram.scopeContextDesc": "Post Context: Ingest original post caption & context for accurate AI answers",
  "instagram.bridgeTitle": "Real-Time Webhook Bridge",
  "instagram.bridgeDesc": "Directly streams payload to Wyzon servers and verifies account subscription.",
  "instagram.scopeWebhookDesc": "Webhook Subscription: Manage live subscription pipes & webhook streams",
  "instagram.scopeIdentityDesc": "Identity Verification: Validate Instagram Business ID & account ownership",
  "instagram.outboundDesc": "Dispatches AI consultative answers to Instagram Direct and replies to comments.",
  "instagram.scopeSendDmDesc": "Send Direct Messages: Deliver AI answers instantly to customer Direct inbox",
  "instagram.scopeReplyCommentsDesc": "Reply to Comments: Publish smart responses to comments and manage engagement",
  "instagram.validation.missingId": "Please enter your Instagram Business Account ID",
  "instagram.validation.missingToken": "Please enter your Page / Access Token",
  "instagram.verifyFailed": "Failed to verify Instagram account. Check your token and account ID.",
  "instagram.connectedToast": "Instagram account verified and connected successfully!",
  "instagram.chatSearchPlaceholder": "Search Instagram chats...",
  "instagram.noChatsTitle": "No messages yet",
  "instagram.noChatsDesc": "Incoming Instagram Direct messages will appear here automatically.",
  "instagram.selectChatTitle": "Instagram Direct Conversations",
  "instagram.selectChatDesc": "Select a conversation to view message history and reply.",
  "instagram.typeReplyPlaceholder": "Type an Instagram Direct reply...",
  "instagram.aiReplyActive": "AI Reply Active",
  "instagram.aiReplyDisabled": "Disabled",
  "instagram.disconnectConfirm": "Are you sure you want to disconnect Instagram?",
  "instagram.howToCreatePermanentToken": "How to create Never-Expire Token?",
  "instagram.hideGuide": "Hide Guide",
  "instagram.permanentGuideTitle": "Steps to generate a Never-Expiring Instagram Token:",
  "instagram.permanentGuideStep1": "Open Meta Business Settings -> go to Users then System Users.",
  "instagram.permanentGuideStep2": "Create a System User with Admin role, click Add Assets and assign your Facebook Page and Instagram Account with Full Control.",
  "instagram.permanentGuideStep3": "Click Generate New Token, select your app, and set Token Expiration to Never.",
  "instagram.permanentGuideStep4": "Select required permissions (instagram_basic, instagram_manage_messages, pages_manage_metadata, pages_read_engagement), copy token and paste here.",
  "instagram.pageNotLinked": "Facebook Page ({{pageName}}) is not linked to an Instagram Business account. Please link it in Page Settings first.",
  "instagram.userTokenRequiresPageToken": "The provided token is a User Access Token. Meta strictly requires a Page Access Token for the linked Facebook Page to access Instagram conversations.",
  "instagram.conversationsRequirePageToken": "Meta requires a Page Access Token (not User Token). Please reconnect using your Page Access Token.",

  // Facebook Hub & Service additions
  "facebook.connectHeaderTitle": "Connect Meta Messenger & Facebook",
  "facebook.pipelineDesc": "Interactive diagram linking Facebook permissions with live event pipelines between Meta and Wyzon",
  "facebook.inboundTitle": "Customer Inbound Interaction",
  "facebook.inboundDesc": "Starts when a customer sends a Messenger message or writes a comment on a post.",
  "facebook.scopeMessengerDesc": "Messenger Ingress: Stream incoming chats, audio & attachments in real-time",
  "facebook.scopeCommentsDesc": "Comments Stream: Ingest visitor comments & reactions on Page feeds",
  "facebook.scopeContextDesc": "Post Context: Ingest original post caption & context for accurate AI answers",
  "facebook.bridgeTitle": "Real-Time Webhook Bridge",
  "facebook.bridgeDesc": "Directly streams payload to Wyzon servers and verifies Page subscription.",
  "facebook.scopeWebhookDesc": "Webhook Subscription: Manage live subscription pipes & webhook streams",
  "facebook.scopeIdentityDesc": "Identity Verification: Validate Page ID, manager rights & account ownership",
  "facebook.tokenPlaceholderHint": "Long-lived Access Token starting with EAA... with required scopes shown in data flow.",
  "facebook.tokenSecurityHint": "Permanent access tokens are securely encrypted on Wyzon servers to prevent unauthorized access.",
  "facebook.verifyingConnecting": "Verifying Permissions & Subscribing Webhooks...",
  "facebook.verifyAndConnectBtn": "Verify & Connect Facebook Page",
  "facebook.verifyFailed": "Failed to verify Facebook Page. Check your token and Page ID.",
  "facebook.connectedToast": "Facebook Page verified and subscribed successfully!",
  "facebook.outboundDesc": "Dispatches AI consultative answers to Messenger and public replies on comments.",
  "facebook.scopeSendDmDesc": "Send Direct Messages: Deliver AI answers directly to customer Messenger inbox",
  "facebook.scopeReplyCommentsDesc": "Reply to Comments: Publish smart responses to comments and manage engagement",
  "instagram.scopeDirectOutDesc": "Direct Egress: Send consultative AI replies & catalogs in chat",
  "instagram.scopeCommentsOutDesc": "Public Engagement: Post public comment reply on customer comments",
  "instagram.scopeBasicOutDesc": "Profile Verification: Dispatch replies verified with official Instagram profile",
  "facebook.scopeManagePostsDesc": "Private DM: Dispatch private Messenger follow-up to public post commenter",
  "facebook.pageNamePlaceholderExample": "e.g. Official Store Page",
  "instagram.webhookConfigSubtitle": "Direct connection credentials to enter in Meta App > Webhooks > Instagram.",
  "channels.routeToWyzon": "Route to Wyzon Endpoint",

  // AiComposer / AiMessageModal
  "aiComposer.title": "AI Composer",
  "aiComposer.close": "Close",
  "aiComposer.textMessage": "Text",
  "aiComposer.voiceNote": "Voice Note",
  "aiComposer.promptLabel": "Message Prompt",
  "aiComposer.promptPlaceholder": "e.g., Thank him for the order, ask for feedback, and offer a 10% discount...",
  "aiComposer.presetThankOrder": "Thank for order",
  "aiComposer.presetThankOrderPrompt": "Thank the customer for their order, tell them we're delighted to serve them, and ask for their feedback",
  "aiComposer.presetDiscount": "Discount offer",
  "aiComposer.presetDiscountPrompt": "Offer a special 10% discount code for their next order as an appreciation",
  "aiComposer.presetShipping": "Shipping update",
  "aiComposer.presetShippingPrompt": "Inform them that their order has been prepared, is being shipped, and will arrive soon",
  "aiComposer.presetFollowup": "Customer follow-up",
  "aiComposer.presetFollowupPrompt": "Ask if they have any questions or need any assistance",
  "aiComposer.generatingDraft": "Generating draft...",
  "aiComposer.draftPreview": "Generated Draft (editable)",
  "aiComposer.processingResponse": "Processing response...",
  "aiComposer.insertToChat": "Insert to chat",
  "aiComposer.sendVoice": "Send Voice",
  "aiComposer.send": "Send",
  "aiComposer.preview": "Preview",
  "aiComposer.copy": "Copy",
  "aiComposer.copied": "Copied",
  "aiComposer.errorNoDraft": "No draft received, please retry.",
  "aiComposer.errorSendFailed": "Failed to send message, please retry.",
  "aiComposer.errorVoiceSendFailed": "Failed to send voice message.",

  // DashboardTopHeader
  "header.listeningToVoice": "Listening to your voice now...",
  "header.listeningClickStop": "Listening... Click to stop",
  "header.speakWithAssistant": "Talk with AI Assistant",

  // DashboardNavRail
  "navRail.theme": "Theme",
  "navRail.colors": "Colors",
};

export default dashboard;
